import { createReducer, on } from '@ngrx/store';

import * as fromAuthLoginActions from '@apps/auth/store/login/login.actions';

import * as fromDepartmentsActions from './departments.actions';
import { IRootDepartmentsState, RootDepartmentsInitialState } from './departments.state';

export const RootDepartmentsReducer = createReducer(
    RootDepartmentsInitialState,
    on(
        fromAuthLoginActions.AuthLogout,
        () => RootDepartmentsInitialState
    ),
    on(
        fromDepartmentsActions.RootDepartmentsRequested,
        (state: IRootDepartmentsState): IRootDepartmentsState =>
            state.isLoaded || state.isLoading
                ? state
                : {
                    ...state,
                    isLoading: true,
                    isOups: false
                }
    ),
    on(
        fromDepartmentsActions.RootDepartmentsSucceeded,
        (state: IRootDepartmentsState, { departments }): IRootDepartmentsState => ({
            ...state,
            departments: [...departments],
            isLoading: false,
            isLoaded: true,
            isEmpty: departments.length === 0,
            isOups: false
        })
    ),
    on(
        fromDepartmentsActions.RootDepartmentsFailed,
        (state: IRootDepartmentsState): IRootDepartmentsState => ({
            ...state,
            departments: [],
            isLoading: false,
            isLoaded: false,
            isEmpty: true,
            isOups: true
        })
    )
);
